import React, { useEffect, useState } from "react";
import { BaseState, StateKeys } from "../../redux/states/main.state";
import {
  ClassResponse,
  CourseResponse,
  TestResponse,
} from "../../services/api.response.service";
import { Col, Row, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import Languages from "../Languages";
import {
  AppState,
  CheckContentProviderIdExist,
  InfoLogger,
  getContentProviderId,
} from "../../services/app.service";
import { RouteEndpoints } from "../../services/route.service";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "../../redux/states";
import Api from "../../services/api.service";
import { toInteger } from "lodash";
import { Mixpanel } from "../../services/mixpanel";

interface props {
  courseDetails: CourseResponse;
  classDetails?: ClassResponse;
}

const SubscribePayButton = ({ courseDetails, classDetails }: props) => {
  const dispatch = useDispatch();

  const stateAll = useSelector((state: IRootState) => state);
  const currentUser = stateAll.setting.user!;

  const { ecampus_id } = useSelector(
    (state: IRootState) => state.setting.user!,
  );

  const subscribe = async (classId: number | undefined) => {
    if (!classId) return;
    if (!ecampus_id) return (window.location.href = RouteEndpoints.SIGN_IN);

    const subscribed = classDetails?.is_subscribed;
    const resObj = subscribed
      ? await Api.unsubscribeClass(classId)
      : await Api.subscribeClass(classId);
    if (resObj) {
      // console.log("the content",resObj.data.data);
      // classDetails = (resObj.data.data);
      // return contentObj.data.data;
    }

    Mixpanel.track(
      subscribed ? "Unsubscribe from a Class" : "Subscribe to Class",
      {
        class_id: classDetails?.id,
        class_name: classDetails?.name,
        user_id: currentUser.id,
        ...(classDetails?.content_provider_id
          ? { content_provider_id: classDetails?.content_provider_id }
          : {}),
      },
    );
    // console.log("Mixpanel - subscribe from a Class", classDetails?.id, classDetails?.name);

    if (
      !classDetails?.has_paid &&
      !subscribed &&
      classDetails?.payment_url &&
      !classDetails.is_free
    ) {
      Mixpanel.track("Class Payment link", {
        class_id: classDetails?.id,
        class_name: classDetails?.name,
        user_id: currentUser.id,
        ...(CheckContentProviderIdExist()
          ? { content_provider_id: getContentProviderId() }
          : {}),
      });
      if (classDetails?.payment_url) {
        window.location.href = classDetails?.payment_url as string;
      }
    } else {
      window.location.reload();
    }
  };

  return (
    <>
      {" "}
      <section id="SubScribePayButton">
        {classDetails ? (
          <>
            {classDetails && classDetails.is_subscribed ? (
              classDetails.has_paid || CheckContentProviderIdExist() ? (
                <>
                  {(courseDetails?.has_read || courseDetails?.has_practice) && (
                    <Link
                      to={RouteEndpoints.COURSE_CONTENT(
                        String(courseDetails?.id),
                      )}
                      // className="text-decoration-none btn btn-primary"
                      className="btn btn-primary ec-btn"
                    >
                      <Languages langKey="startLearning" />
                      {""}
                    </Link>
                  )}
                </>
              ) : (
                <a
                  href={classDetails.payment_url!}
                  target="_blank"
                  // className="text-decoration-none btn btn-primary"
                  className="btn btn-primary ec-btn"
                  rel="noreferrer"
                >
                  <Languages langKey="payToAccessContent" />{" "}
                </a>
              )
            ) : (
              <button
                // className="text-decoration-none btn btn-primary"
                className="btn btn-primary ec-btn"
                onClick={() =>
                  CheckContentProviderIdExist()
                    ? null
                    : subscribe(classDetails?.id)
                }
                disabled={
                  // classDetails == undefined ||
                  CheckContentProviderIdExist()
                }
              >
                {CheckContentProviderIdExist() ? (
                  <Languages langKey="contentAdminCourse" />
                ) : (
                  <Languages langKey="subToStartLearn" />
                )}
              </button>
            )}
          </>
        ) : (
          <>
            {" "}
            {/*<Link*/}
            {/*  to={RouteEndpoints.COURSE_CONTENT(*/}
            {/*    String(courseDetails?.id)*/}
            {/*  )}*/}
            {/*  className="text-decoration-none btn btn-primary"*/}
            {/*>*/}
            {/*  <Languages langKey="startLearning" />{""}*/}
            {/*</Link>*/}
          </>
        )}

        {/*</div>*/}
      </section>{" "}
    </>
  );
};

export default SubscribePayButton;
